import {ModuleNode, extractModuleIdentifiers} from '@backstage-components/base';
import React, {FC} from 'react';
import {SchemaType} from './DateDefinition';
import {DateComponent} from './DateComponent';

export type DateProps = SchemaType;

export const DatePreviewComponent: FC<ModuleNode<'Date', DateProps>> = (
  definition
) => {
  const {props} = definition.module;
  return (
    <div style={{pointerEvents: 'none'}}>
      <DateComponent
        component={definition.module.component}
        config={{scope: 'admin'}}
        {...extractModuleIdentifiers(definition.module)}
        props={props}
      />
    </div>
  );
};
